<template>
  <div class="cc-form show">
    <div class="data-field">
      <div class="label">Credit Card #</div>
      <div id="card-element"></div>
    </div>

    <div class="data-field">
      <div class="label">Cardholder Name</div>
      <input type="text" :class="['input', {'has-error':!!validation.userCardOwner}]" v-model="cardOwner" />
      <span class="error-msg">{{ validation.userCardOwner }}</span>
    </div>

    <div class="data-field">
      <div class="label">Address</div>
      <input type="text" :class="['input', {'has-error':!!validation.address}]" v-model="address" />
      <span class="error-msg">{{ validation.address }}</span>
    </div>

    <div class="data-field">
      <div class="label">City</div>
      <input type="text" :class="['input', {'has-error':!!validation.userCity}]" v-model="userCity" />
      <span class="error-msg">{{ validation.userCity }}</span>
    </div>

    <div class="d-flex state-zip">
      <div class="data-field">
        <div class="label">State</div>
        <select v-model="userState" :class="{'has-error':!!validation.userState}">
          <option :value="null" disabled :class="{'hideDesktop':isDesktop, 'showMobile':isMobile}"></option>
          <option value=".."></option>
          <option value="">Non US</option>
          <option v-for="state in states" :value="state.value">{{state.label}}</option>
        </select>
        <span class="error-msg">{{ validation.userState }}</span>
      </div>

      <div class="data-field">
        <div class="label">Zip</div>
        <input type="text" :class="['input', {'has-error':!!validation.userZip}]" v-model="userZip" />
        <span class="error-msg">{{ validation.userZip }}</span>
      </div>
    </div>

    <div class="data-field" v-show="userState === ''">
      <div class="label">Country</div>
      <select v-model="userCountry" :class="['input', {'has-error':!!validation.userCountry}]">
        <option :value="null" disabled :class="{'hideDesktop':isDesktop, 'showMobile':isMobile}"></option>
        <option v-for="country in countries.all" :value="country.alpha2">{{country.name}}</option>
      </select>
      <span class="error-msg">{{ validation.userCountry }}</span>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import US from 'us'

export default {
  name: 'stripe-payment-form',
  data () {
    return {
      stripe: null,
      cardElement: null,
      validation: {
        cardOwner: '',
        address: '',
        userCity: '',
        userState: '',
        userZip: '',
        userCountry: '',
      },
      isMobile: false,
      isDesktop: false,
      countries: require('country-data').countries
    }
  },
  computed: {
    states () {
      let states = []
      for (let key in US.states) {
        if (US.states.hasOwnProperty(key)) {
          states.push({
            value: key,
            label: US.states[key].name
          })
        }
      }
      return states
    },
    edit () { return this.$store.state.rsvpDetails.edit.details },
    stripeStore () { return this.$store.state.rsvpDetails.stripe },
    cardOwner: {
      get () { return this.stripeStore.cardOwner },
      set (x) { this.$store.commit('rsvpDetails/setStripeData', {cardOwner: x}) }
    },
    address: {
      get () { return this.stripeStore.address },
      set (x) { this.$store.commit('rsvpDetails/setStripeData', {address: x}) }
    },
    userCity: {
      get () { return this.stripeStore.userCity },
      set (x) { this.$store.commit('rsvpDetails/setStripeData', {userCity: x}) }
    },
    userState: {
      get () { return this.stripeStore.userState },
      set (x) {
        this.$store.commit('rsvpDetails/setStripeData', {userState: x})
        if (x) this.$store.commit('rsvpDetails/setStripeData', {userCountry: ''})
      }
    },
    userZip: {
      get () { return this.stripeStore.userZip },
      set (x) { this.$store.commit('rsvpDetails/setStripeData', {userZip: x}) }
    },
    userCountry: {
      get () { return this.stripeStore.userCountry },
      set (x) { this.$store.commit('rsvpDetails/setStripeData', {userCountry: x}) }
    }
  },
  methods: {
    setScreenSize() {
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        this.isDesktop = false
        this.isMobile = true
      } else {
        this.isDesktop = true
        this.isMobile = false
      }
    },
    validate () {
      this.validation = {
        cardOwner: '',
        address: '',
        userCity: '',
        userState: '',
        userZip: '',
        userCountry: ''
      }

      let hasError = false
      if (!this.cardOwner) {
        this.validation.userCardOwner = this.$t('rsvpDetails.edit.emptyField')
        hasError = true
      }
      if (!this.address) {
        this.validation.userAddress = this.$t('rsvpDetails.edit.emptyField')
        hasError = true
      }
      if (!this.userCity) {
        this.validation.userCity = this.$t('rsvpDetails.edit.emptyField')
        hasError = true
      }
      if (this.userState === '..') {
        this.validation.userState = this.$t('rsvpDetails.edit.emptyField')
        hasError = true
      }
      if (this.userCountry === '' && !this.userState) {
        this.validation.userCountry = this.$t('rsvpDetails.edit.emptyField')
        hasError = true
      }

      if (hasError) retturn
    },
    submitStripe (id, client_secret) {
      let self = this
      self.stripe.confirmCardSetup(client_secret, {
        payment_method: {
          card: self.cardElement,
          billing_details: {
            name: self.cardOwner,
            address: {
              city: self.userCity,
              country: self.userCountry || 'US',
              line1: self.address,
              state: self.userState
            }
          }
        }
      }).then(result => {
        if (result.error) {
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: result.error.message
          })
          return
        }
        self.addCard(id, result)
      })
    },
    addCard (id, result) {
      let self = this
      self.$sdk.post(`/consumer/${id}/cards/token`, {
        token: self.$store.state.session.sessionToken,
        paymentMethodId: result.setupIntent.payment_method
      }, r => {
        if (r.error) {
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }
        let cards = []
        r.cards.forEach(data => {
          cards.push({
            id: data.ID,
            name: data.title + ' ****-' + data.cardNumber.substr(-4)
          })
        })
        self.$store.commit('rsvpDetails/setUserCardList', cards)
        self.$emit('cardAdded')

        // let card = r.cards[0]
        // self.$store.commit('setSelectedCard', {
        //   id: card.ID,
        //   type: card.title,
        //   number: card.cardNumber,
        //   exp: card.cardExpires,
        //   className: self.parseCardClass(card)
        // })
        // if (self.bookingType === 'flight') {
        //   self.$emit('done')
        //   // self.$root.$router.push('review-summary')
        // } else {
        //   self.$root.$router.push('review')
        // }
      }, '1.1')
    }
  },
  mounted () {
    this.stripe = Stripe(CONFIG.Stripe.publishableKey) // eslint-disable-line
    let elements = this.stripe.elements({
      fonts: [{cssSrc: 'https://fonts.googleapis.com/css2?family=Questrial&display=swap'}]
    })
    this.cardElement = elements.create('card')
    this.cardElement.mount('#card-element')

    this.setScreenSize()
  }
}
</script>

<style lang="scss" scoped>
.cc-form{
  transform-origin: top center;
  display: none;
  padding: 15px 20px;
  background: #f5f5f5;

  &.show{ display: block; }
}

.data-field{
  position: relative;
  margin-bottom: 10px;

  &.no-label{ padding-top: 17px; }
  .label{
    color: #888;
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    line-height: 130%;
    letter-spacing: .5px;

    &.has-error{ color: #f20d0d; }
    &.bigger{ font-size: 14px; }
    small{
      color: #bbb;
      margin-left: 5px;
      vertical-align: 2px;
    }
  }
  .value{
    font-weight: 600;
    font-size: 17px;
    color: #555;

    a{
      text-decoration: underline;
      cursor: pointer;
      word-wrap: break-word;
    }
  }
  .description{
    font-size: 11px;
    color: #999;
    font-style: italic;
    display: block;
    color: #ff8d00;
  }
  .input{
    margin: 2px 0 0;
    color: #333;
    line-height: inherit;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background: #eee; }
  }
  textarea{
    border: 1px solid #ddd;
    width: 100%;
    height: 100px;
    resize: none;
    padding: 10px;
    font-size: 13px;
    color: #555;
    outline: none;
    margin: 5px 0 0;
  }
  select{
    margin-top: 5px;
    border: 1px solid #ddd;
    padding: 10px;
    color: #333;
    height: 45px;
    position: relative;
    font-size:14px;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url('/assets/img/dropdown-arrow.png');
    background-repeat: no-repeat;
    background-position: right 50%;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background-color: #eee; }
  }
  .checkbox{
    line-height: 100%;
    margin-bottom: 3px;

    &.inline{
      display:inline-block;
      margin: 0 25px 10px 0;
    }
    &:last-child{ margin-bottom: 0; }
    input{
      display: inline-block;
      width: auto;
      vertical-align: -2px;
      margin: 0 5px 0 0;
    }
    label{
      font-size: 14px;
      color: #555;
      line-height: 150%;
    }
  }
  .radio{
    display: block;
    color: #333;
    font-size: 14px;
    margin-top: 5px;

    &:first-child{ margin-top: 5px; }
    input[type="radio"]{
      display: inline-block;
      width: auto;
      margin: 0 0 0 5px;
      vertical-align: middle;
      cursor: pointer;
    }
    .radio-fa{
      margin: 20px 10px 0 0;
      color: #aaa;
      transition: all .5s ease;

      &.checked{
        color:#57d1b7;
        &:before{
          content: "\f192";
        }
      }
    }
    &.with-textbox{
      display: flex;

      input[type="radio"]{ margin: 15px 10px 0 0; }
      .input{
        display: inline-block;
        vertical-align: middle;
      }
    }
    &.label-only{
      .radio-fa{ margin: 0 10px 10px 0; }
    }
  }
  .error-msg{
    font-size: 11px;
    line-height: 1.6;
    color: #f20d0d;
    font-style: italic;
    display: block;
  }
}

#card-element{
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 15px;
  background: #fbfbfb;
  box-shadow: inset 1px 1px 2px rgba(0,0,0,.1);
}

.state-zip{
  gap: 15px;

  .data-field{
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/RsvpDetails/StripeForm.vue